import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { IIncident } from '@/api/routes/incidents/types';
import type { ResponseWithPagination } from '@/utils/types';

import { fetchIncidentsFull } from './actionCreators';

interface InitialState {
  incidents: IIncident [],
  offset: number,
  totalCount: number,
  prevTotalCount: number,
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  incidents: [],
  offset: 0,
  totalCount: 0,
  prevTotalCount: 0,
  isLoading: false,
  error: '',
};

export const incidentsSlice = createSlice({
  name: 'incidents',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchIncidentsFull.fulfilled.type]: (state, action: PayloadAction<ResponseWithPagination<IIncident>>) => {
      state.isLoading = false;
      state.error = '';
      state.incidents = action.payload.rows;
      state.offset = action.payload.offset;
      state.prevTotalCount = state.totalCount;
      state.totalCount = action.payload.total_count;
    },
    [fetchIncidentsFull.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchIncidentsFull.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default incidentsSlice.reducer;
